module.exports = __webpack_public_path__ + "img/wormani.b3dc893b.jpg";